import React from 'react';
import { Icon } from 'semantic-ui-react';

const FormHeaderButton = ({
  icon,
  label,
  className = '',
  onClick = () => {},
  type = 'button',
  ...rest
}) => {
  if (label) {
    return (
      <div
        className={`ui labeled button ${className}`}
        onClick={onClick}
        role="button"
        tabIndex={0}
        {...rest}
      >
        <button className="ui icon button" type={type} aria-label={label}>
          <Icon name={icon} />
        </button>
        <div className="ui basic left pointing label">{label}</div>
      </div>
    );
  }

  return (
    <button
      className={`ui icon button ${className}`}
      onClick={onClick}
      type={type}
      aria-label={icon}
      {...rest}
    >
      <Icon name={icon} />
    </button>
  );
};

export default FormHeaderButton;
